/* eslint-disable prefer-const */

import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import { darken } from '@material-ui/core/styles/colorManipulator'
import cn from 'classnames'
import moment from 'moment'
import { useEffect, useState } from 'react'

const styles = theme => ({
  wrapper: {
    width: '100%',
    maxWidth: 510,
  },
  time: {
    display: 'flex',
    justifyContent: 'space-between',
    '& > div': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'space-between',
      justifyContent: 'center',
      textAlign: 'center',
    },
  },
  numWrap: {
    maxWidth: 112,
  },
  num: {
    color: `var(--gameday-body-headingColor, ${theme.body.headingColor})`,
    fontSize: props => (props.size === 'md' ? 'clamp(18px, 5vw, 40px)' : 'clamp(36px, 10vw, 80px)'),
    fontWeight: props => (props.size === 'md' ? '450' : '900'),
    lineHeight: 1,
  },
  label: {
    fontSize: props => (props.size === 'md' ? '12px' : '24px'),
    fontWeight: props => (props.size === 'md' ? '250' : '500'),
    color: theme.colors.darkGrey,
    [theme.breakpoints.down(700)]: {
      fontSize: '16px',
    },
    [theme.breakpoints.down(400)]: {
      fontSize: '14px',
    },
  },
  finished: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '30px 0',
  },
  message: {
    fontSize: '28px',
    textAlign: 'center',
    fontWeight: 500,
  },
})

const CountdownButton = withStyles(() => ({
  root: props => ({
    margin: '16px 0',
    color: props.buttonTextColor && props.buttonTextColor,
    backgroundColor: props.buttonBGColor && props.buttonBGColor,
    border: 'none',
    '&:hover': {
      backgroundColor: props.buttonBGColor && darken(props.buttonBGColor, 0.08),
    },
  }),
}))(Button)

function Countdown({
  buttonBGColor,
  buttonLabel,
  buttonTextColor,
  classes,
  completeMessage,
  date,
  dateFormat,
  hideOnComplete,
  onClick,
  onComplete,
  withButton,
  timezone,
}) {
  const [days, setDays] = useState()
  const [hours, setHours] = useState()
  const [minutes, setMinutes] = useState()
  const [seconds, setSeconds] = useState()
  const [showCountdown, setShowCountdown] = useState(true)

  useEffect(() => {
    const interval = setInterval(() => {
      const then = timezone ? moment.tz(date, dateFormat, timezone) : moment(date, dateFormat)
      const now = timezone ? moment.tz(timezone) : moment()
      const duration = moment.duration(then.diff(now))
      const days = duration.asDays()
      const hours = duration.hours()
      const minutes = duration.minutes()
      const seconds = duration.seconds()
      const milliseconds = duration.milliseconds()
      if (milliseconds < 0 && hideOnComplete) {
        setShowCountdown(false)
        onComplete()
      }
      if (days < 1) {
        setDays(0)
      } else {
        setDays(days.toFixed(0))
      }
      setHours(hours)
      setMinutes(minutes)
      setSeconds(seconds)
    }, 1000)

    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  })

  return (
    <div className={classes.wrapper}>
      {showCountdown ? (
        <div className={classes.time}>
          {(days || days >= 0) && (
            <div className={cn(classes.days, classes.numWrap)}>
              <span className={classes.num}>{days >= 0 ? days : 0}</span>
              <span className={classes.label}>days</span>
            </div>
          )}
          {(hours || hours === 0) && (
            <div className={cn(classes.hours, classes.numWrap)}>
              <span className={classes.num}>{hours >= 0 ? hours : 0}</span>
              <span className={classes.label}>hours</span>
            </div>
          )}
          {(minutes || minutes === 0) && (
            <div className={cn(classes.mins, classes.numWrap)}>
              <span className={classes.num}>{minutes >= 0 ? minutes : 0}</span>
              <span className={classes.label}>minutes</span>
            </div>
          )}
          {(seconds || seconds === 0) && (
            <div className={cn(classes.secs, classes.numWrap)}>
              <span className={classes.num}>{seconds >= 0 ? seconds : 0}</span>
              <span className={classes.label}>seconds</span>
            </div>
          )}
        </div>
      ) : (
        <div className={classes.finished}>
          <div className={classes.message}>{completeMessage}</div>
          {withButton && (
            <CountdownButton
              buttonBGColor={buttonBGColor}
              buttonTextColor={buttonTextColor}
              color="primary"
              onClick={onClick}
              size="large"
              variant="contained"
            >
              {buttonLabel}
            </CountdownButton>
          )}
        </div>
      )}
    </div>
  )
}

Countdown.defaultProps = {
  buttonLabel: 'Click to Continue',
  completeMessage: 'The countdown has ended',
  onClick: () => window.location.reload(),
}

const CountdownComponent = withStyles(styles)(Countdown)
CountdownComponent.displayName = 'Countdown'
export default CountdownComponent
